import React from "react";
import { LayoutMain } from "../../../../boxes/LayoutMain/LayoutMain";
import styles from "./styles.module.scss";
import { Header } from "./shared/Header";
import { Box } from "../../../../shared/Box/Box";
import { Filter } from "./shared/Filter";
import { Table } from "./shared/Table";
import { useDocuments } from "./hooks/useDocuments";
import { useMultiselectEntity } from "../../../../utilities/hooks/useMultiselectEntity";

export function PatientDocuments() {
  var { documents, order, search, period, filter } = useDocuments();

  var selection = useMultiselectEntity({
    allEntities: documents.value.map((x) => x.id),
  });

  return (
    <LayoutMain>
      <div className={styles.root}>
        <Header selection={selection} />
        <Box className={styles.content}>
          <Filter
            search={search}
            filter={filter}
            period={period}
            docTypes={documents.docTypes}
          />
          <Table documents={documents} order={order} selection={selection} />
        </Box>
      </div>
    </LayoutMain>
  );
}
